const STATUS_FETCH_PENDING = `STATUS_FETCH_PENDING`;
const STATUS_FETCH_SUCCESS = `STATUS_FETCH_SUCCESS`;
const STATUS_FETCH_ERROR = `STATUS_FETCH_ERROR`;

export default {
  STATUS_FETCH_PENDING,
  STATUS_FETCH_SUCCESS,
  STATUS_FETCH_ERROR,
};
